module.exports = "../images/moose-bg.jpg?v=8e80bc6";